import { UserDetailedInterface, UserInterface } from 'app/core/user/models';

import { ErgoTeamMemberInterface } from '../../models/ergo-team-member.model';

export interface UserStateInterface {
  ids?: number[];
  users?: { [id:number]: UserInterface };
  selectedUser?: number;
  adminUsers?: UserInterface[];
  detailedUsers?: { [id:number]: UserDetailedInterface };
  selectedProfileUser?: UserInterface;
  selectedProfileErgoTeam?: ErgoTeamMemberInterface[];
}

export class UserState implements UserStateInterface {
  public ids?: number[];
  public users?: { [id:number]: UserInterface };
  public selectedUser?: number;
  public adminUsers?: UserInterface[];
  public detailedUsers?: { [id:number]: UserDetailedInterface };
  public selectedProfileUser?: UserInterface;
  public selectedProfileErgoTeam?: ErgoTeamMemberInterface[];

  constructor({
    ids = undefined,
    users = undefined,
    selectedUser = undefined,
    adminUsers = undefined,
    detailedUsers = undefined,
    selectedProfileUser = undefined,
    selectedProfileErgoTeam = undefined,
    }: UserStateInterface) {
    this.ids = ids;
    this.users = users;
    this.selectedUser = selectedUser;
    this.adminUsers = adminUsers;
    this.detailedUsers = detailedUsers;
    this.selectedProfileUser = selectedProfileUser;
    this.selectedProfileErgoTeam = selectedProfileErgoTeam;
  }
}
